import {
  CentraCheckoutApiProduct,
  CentraCheckoutApiProductItem,
} from "@made-people/centra-checkout-api";
import {
  ProductPurchaseInfo,
  ProductPurchaseInventory,
} from "@made-people/grease-product";
import {
  CentraCheckoutApiMapperOptions,
  CentraCheckoutApiMappers,
} from "@made-people/grease-centra";

export const mmPurchaseInfo: CentraCheckoutApiMappers["centraCheckoutApiItemToGreasePurchaseInfo"] =
  (
    product: CentraCheckoutApiProduct,
    item: CentraCheckoutApiProductItem,
    _options?: CentraCheckoutApiMapperOptions,
  ): ProductPurchaseInfo => {
    const isDiscounted =
      product.priceAsNumber !== product.priceBeforeDiscountAsNumber;
    const discountPercent = Math.round(
      (1 - product.priceAsNumber / product.priceBeforeDiscountAsNumber) * 100,
    );

    const quantity =
      typeof item.stock === "number"
        ? item.stock
        : item.stock === "yes"
          ? 1
          : 0;

    const inStock = quantity > 0;

    const warehouses = item.warehouses ?? [];

    const additionalInventory: ProductPurchaseInventory[] = warehouses.map(
      (w) => ({
        quantity: w.stock ?? 0,
        inStock: (w.stock ?? 0) > 0,
        warehouseId: String(w.warehouse ?? 0),
      }),
    );

    return {
      sku: item.sku,
      inventory: {
        quantity,
        inStock,
        warehouseId: "1",
      },
      additionalInventory,
      priceInfo: {
        price: { formatted: product.price, number: product.priceAsNumber },
        priceWithoutDiscount: {
          formatted: product.priceBeforeDiscount,
          number: product.priceBeforeDiscountAsNumber,
        },

        previouslyDiscountedPrices: product.lowestPrice?.map((lp) => ({
          date: new Date(Date.now() - lp.periodDays * 24 * 60 * 60 * 1000),
          periodDays: lp.periodDays,
          price: { formatted: lp.price, number: lp.priceAsNumber },
          priceWithoutDiscount: {
            formatted: lp.priceBeforeDiscount,
            number: lp.priceBeforeDiscountAsNumber,
          },
        })),
        discountInfo: isDiscounted
          ? {
              percent: discountPercent,
            }
          : undefined,
      },
    };
  };
